var burger;

burger = function() {
  var $, module, moduleName;
  $ = require('jquery');
  moduleName = 'burger';
  module = $("." + moduleName);
  return module.click(function(e) {
    var thisMod;
    thisMod = $(this);
    thisMod.toggleClass(moduleName + "--enabled");
    return $(document).keyup(function(e) {
      if (e.keyCode === 27) {
        return thisMod.removeClass(moduleName + "--enabled");
      }
    });
  });
};

module.exports = burger;
